function normalizeRole(role) {
  return typeof role === "string" ? role.trim().toLowerCase() : null;
}

function normalizeEmail(email) {
  return typeof email === "string" ? email.trim().toLowerCase() : null;
}

export function getCreatorEmailAllowlist() {
  return new Set(
    (process.env.REACT_APP_CREATOR_EMAILS || "max.petrusenko@gmail.com")
      .split(",")
      .map(normalizeEmail)
      .filter(Boolean)
  );
}

export function isCreatorEmail(email) {
  const normalizedEmail = normalizeEmail(email);
  return Boolean(normalizedEmail && getCreatorEmailAllowlist().has(normalizedEmail));
}

function collectRoles(source, roles) {
  if (!source || typeof source !== "object") return;

  const singleRole = normalizeRole(source.role);
  if (singleRole) roles.add(singleRole);

  if (Array.isArray(source.roles)) {
    source.roles
      .map(normalizeRole)
      .filter(Boolean)
      .forEach((role) => roles.add(role));
  }

  if (source.isCreator) roles.add("creator");
  if (source.isAdmin) roles.add("admin");
}

export function getUserRoles(user) {
  const roles = new Set();
  collectRoles(user, roles);
  collectRoles(user?.claims, roles);
  collectRoles(user?.customClaims, roles);
  return roles;
}

export function hasCreatorAccess(user) {
  if (!user) return false;
  const roles = getUserRoles(user);
  return roles.has("creator") || roles.has("admin");
}

export function hasAdminAccess(user) {
  if (!user) return false;
  return getUserRoles(user).has("admin");
}
